import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useMemo, useEffect } from 'react';
import { isBrowser } from '@phx-husky/browser-helpers';
var ConditionOperator;
(function (ConditionOperator) {
  ConditionOperator["GT"] = "Gt";
  ConditionOperator["LT"] = "Lt";
  ConditionOperator["GE"] = "Ge";
  ConditionOperator["LE"] = "Le";
  ConditionOperator["EQ"] = "Eq";
  ConditionOperator["NE"] = "Ne";
})(ConditionOperator || (ConditionOperator = {}));
var parseExpected = function parseExpected(actual, expected) {
  if (Array.isArray(expected)) return expected.filter(function (item) {
    return item;
  });
  if (typeof actual === 'boolean') return expected === 'true';
  if (typeof actual === 'number') return parseInt(expected, 10);
  if (actual instanceof Date) return new Date(expected);
  return expected;
};
var checkCondition = function checkCondition(actual, expected, operator) {
  if ([null, undefined, NaN].includes(actual)) return false;
  var parsedExpected = parseExpected(actual, expected);
  switch (operator) {
    case ConditionOperator.EQ:
      if (Array.isArray(actual) && Array.isArray(parsedExpected)) return actual.length === parsedExpected.length && actual.every(function (item, ind) {
        return parsedExpected[ind] === item;
      });
      return Array.isArray(parsedExpected) ? parsedExpected.includes((actual === null || actual === void 0 ? void 0 : actual.value) || actual) : parsedExpected === actual;
    case ConditionOperator.NE:
      if (Array.isArray(actual) && Array.isArray(parsedExpected)) return !actual.some(function (item) {
        return parsedExpected.includes(item);
      });
      return Array.isArray(parsedExpected) ? !parsedExpected.includes((actual === null || actual === void 0 ? void 0 : actual.value) || actual) : parsedExpected !== actual;
    case ConditionOperator.GT:
      return actual > parsedExpected;
    case ConditionOperator.GE:
      return actual >= parsedExpected;
    case ConditionOperator.LT:
      return actual < parsedExpected;
    case ConditionOperator.LE:
      return actual <= parsedExpected;
    default:
      return null;
  }
};
var useConditionsWatch = function useConditionsWatch(watch, conditions) {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    shouldRender = _useState2[0],
    setShouldRender = _useState2[1];
  var cond = useMemo(function () {
    return conditions || [];
  }, [conditions]);
  var watched = cond.map(function (_ref) {
    var fieldAlias = _ref.fieldAlias;
    return watch(fieldAlias);
  });
  useEffect(function () {
    var fullfilled = cond.every(function (_ref2, index) {
      var value = _ref2.value,
        operator = _ref2.operator;
      return checkCondition(watched[index], value, operator);
    });
    setShouldRender(fullfilled);
  }, [cond, watched]);
  if (!cond.length) return true;
  return shouldRender;
};
var utmParameters = ['utm_id', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
var parseRegex = function parseRegex(regex) {
  if (!regex) {
    return undefined;
  }
  var parts = /\/(.*)\/(.*)/.exec("".concat(regex)) || /\/(.*)\/(.*)/.exec("/".concat(regex, "/"));
  return parts ? new RegExp(parts[1], parts[2]) : undefined;
};
var getQueries = function getQueries(description) {
  var _a;
  return description ? (_a = Object.values(JSON.parse(description).entityMap)) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
    return item.type === 'LEGAL-DOCUMENT';
  }) : [];
};
var getUtmParameters = function getUtmParameters() {
  if (!isBrowser()) {
    return undefined;
  }
  return utmParameters.map(function (utm) {
    var searchParams = new URLSearchParams(window.location.search);
    var paramValue = new URLSearchParams(searchParams).get(utm);
    return {
      name: utm,
      value: paramValue || undefined
    };
  });
};
export { ConditionOperator, getQueries, getUtmParameters, parseRegex, useConditionsWatch };